"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disposeCanvas = exports.initFabricCanvas = exports.CANVAS_CONTAINER_PARENT_ID = exports.CANVAS_CONTAINER_ID = exports.CANVAS_ID = void 0;
var fabric_1 = require("fabric");
var nanoid_1 = require("nanoid");
var WorkareaObject_1 = require("../Objects/WorkareaObject");
var CANVAS_CONTAINER_PARENT_ID = 'editor-container';
exports.CANVAS_CONTAINER_PARENT_ID = CANVAS_CONTAINER_PARENT_ID;
var CANVAS_CONTAINER_ID = 'editor-canvas-container';
exports.CANVAS_CONTAINER_ID = CANVAS_CONTAINER_ID;
var CANVAS_ID = 'main-canvas';
exports.CANVAS_ID = CANVAS_ID;
// try disabling objectCaching to prevent canvas memory consumption
fabric_1.fabric.Object.prototype.objectCaching = false;
var initCanvas = function () {
    return new fabric_1.fabric.Canvas(CANVAS_ID, {
        backgroundColor: '#f3f3f3'
    });
};
var initWorkarea = function (_a) {
    var width = _a.width, height = _a.height;
    return new WorkareaObject_1.FabricWorkarea({ id: (0, nanoid_1.nanoid)(), version: '1.0' }, {
        scaleX: 1,
        scaleY: 1,
        width: width,
        height: height
    });
};
var setCustomConfig = function (canvas, cb) {
    canvas.setBackgroundColor('#f3f3f3', function () {
        ;
        window.canvas = null;
        window.canvas = canvas;
        var workarea = canvas.getObjects()[0];
        // set workarea props
        if (workarea && (0, WorkareaObject_1.isFabricWorkareaObject)(workarea)) {
            window.workarea = workarea;
        }
        canvas.renderAll();
        if (cb) {
            cb();
        }
    });
};
var initFabricCanvas = function (_a) {
    var resolution = _a.resolution, canvasJson = _a.canvas, onSuccessCallback = _a.onSuccessCallback;
    var canvas = initCanvas();
    // load canvas if stored
    if (canvasJson === null || canvasJson === void 0 ? void 0 : canvasJson.version) {
        canvas.loadFromJSON(canvasJson, function () {
            setCustomConfig(canvas, function () {
                if (onSuccessCallback) {
                    onSuccessCallback();
                }
            });
        });
    }
    else {
        var workarea = initWorkarea(resolution);
        canvas.add(workarea);
        setCustomConfig(canvas, function () {
            if (onSuccessCallback) {
                onSuccessCallback();
            }
        });
    }
    return canvas;
};
exports.initFabricCanvas = initFabricCanvas;
var disposeCanvas = function () {
    if (window.canvas) {
        window.canvas.dispose();
    }
};
exports.disposeCanvas = disposeCanvas;
//# sourceMappingURL=initCanvas.js.map